// extracted by mini-css-extract-plugin
export var externalLink = "_bk-0";
export var internalLinkLabel = "_bk-1";